import { getConsumer } from './consumer';

export function subscribeToConversation(conversationId, callbacks = {}) {
  const consumer = getConsumer();

  return consumer.subscriptions.create(
    {
      channel: 'Chat::ConversationChannel',
      conversation_id: conversationId
    },
    {
      connected() {
        if (callbacks.onConnected) callbacks.onConnected();
      },

      disconnected() {
        if (callbacks.onDisconnected) callbacks.onDisconnected();
      },

      received(data) {
        if (data.type === 'new_message' && callbacks.onMessage) {
          callbacks.onMessage(data.message);
        } else if (data.type === 'message_hidden' && callbacks.onMessageHidden) {
          callbacks.onMessageHidden(data.message_id, data.hidden);
        } else if (data.type === 'message_deleted' && callbacks.onMessageDeleted) {
          callbacks.onMessageDeleted(data.message_id);
        } else if (data.type === 'message_edited' && callbacks.onMessageEdited) {
          callbacks.onMessageEdited(data.message);
        } else if (data.type === 'read_receipt' && callbacks.onReadReceipt) {
          callbacks.onReadReceipt(data.user_id, data.last_read_at);
        } else if (data.type === 'reaction' && callbacks.onReaction) {
          callbacks.onReaction(data);
        }
      }
    }
  );
}
